export default "__VITE_ASSET__ebN3kLJL__"